import './App.css';
import TaxCalculator from "./TaxCalculator/TaxCalculator";
import 'bootstrap/dist/css/bootstrap.min.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';

function App() {
  return (
    <div className="App">
      <TaxCalculator />
    </div>
  );
}

export default App;
